<template>
  <div>
    <c-title>Förderprogramm</c-title>
    <c-process-overview />
  </div>
</template>

<script>
import CProcessOverview from '@/components/process/CProcessOverview'
import CTitle from '@/components/CTitle'

export default {
  name: 'VProcessIntroduction',

  components: {
    CProcessOverview,
    CTitle
  }
}
</script>
